//BUY SELL CONSTANTS
export const GET_ALL_BUY_SELL_ITEMS = "GET_ALL_BUY_SELL_ITEMS";
export const GET_SINGLE_BUY_SELL_ITEM = "GET_SINGLE_BUY_SELL_ITEM";
export const ADD_NEW_BUY_SELL_ITEM = "ADD_NEW_BUY_SELL_ITEM";
export const NEW_REQUEST = "NEW_REQUEST";
export const GET_MY_OWN_BUY_SELL_ITEMS = "GET_MY_OWN_BUY_SELL_ITEMS";
export const EDIT_BUY_SELL_ITEM = "EDIT_BUY_SELL_ITEM";
export const DELETE_BUY_SELL_ITEM = "DELETE_BUY_SELL_ITEM";
export const CHECKING_ERROR_BUY_SELL = "CHECKING_ERROR_BUY_SELL";
export const SEARCH_BUY_SELL_ITEMS = "SEARCH_BUY_SELL_ITEMS";
export const EMPTY_SEARCH_BUY_SELL = "EMPTY_SEARCH_BUY_SELL";
export const MAKE_CONNECTION = "MAKE_CONNECTION";

//LOST FOUND CONSTANTS
export const GET_ALL_LOST_FOUND_ITEMS = "GET_ALL_LOST_FOUND_ITEMS";
export const SEARCH_LOST_FOUND_ITEMS = "SEARCH_LOST_FOUND_ITEMS";
export const EMPTY_SEARCH_LOST_FOUND = "EMPTY_SEARCH_LOST_FOUND";
export const GET_SINGLE_LOST_FOUND_ITEM = "GET_SINGLE_LOST_FOUND_ITEM";
export const ADD_NEW_LOST_FOUND_ITEM = "ADD_NEW_LOST_FOUND_ITEM";
export const GET_MY_OWN_LOST_FOUND_ITEMS = "GET_MY_OWN_BLOST_FOUND_ITEMS";
export const EDIT_LOST_FOUND_ITEM = "EDIT_LOST_FOUND_ITEM";
export const DELETE_LOST_FOUND_ITEM = "DELETE_LOST_FOUND_ITEM";
export const MARK_AS_FOUND = "MARK_AS_FOUND";
export const GET_LOST_FOUND_RESPONSES = "GET_LOST_FOUND_RESPONSES";
export const ACCEPT_RAISED_HAND = "ACCEPT_RAISED_HAND";
export const REJECT_RAISED_HAND = "REJECT_RAISED_HAND";

export const CHECKING_ERROR_LOST_FOUND = "CHECKING_ERROR_LOST_FOUND";

//REQUIREMENTS CONSTANTS
export const GET_ALL_REQUIREMENTS = "GET_ALL_REQUIREMENTS";
export const ADD_NEW_REQUIREMENT = "ADD_NEW_REQUIREMENT";
export const GET_MY_OWN_REQUIREMENTS = "GET_MY_OWN_REQUIREMENTS";
export const EDIT_REQUIREMENT = "EDIT_REQUIREMENT";
export const RESET_STATUS = "RESET_STATUS";
export const NEW_REQUEST_REQUIREMENT = "NEW_REQUEST_REQUIREMENT";
export const DELETE_REQUIREMENT = "DELETE_REQUIREMENT";
export const CHECKING_ERROR_REQUIREMENTS = "CHECKING_ERROR_REQUIREMENTS";

//USER CONSTANTS
export const SET_USER = "SET_USER";
export const USER_LOGOUT = "USER_LOGOUT";
export const VERIFY_EMAIL = "VERIFY_EMAIL";
export const VERIFY_EMAIL_FOR_RESET = "VERIFY_EMAIL_FOR_RESET";
export const VERIFY_OTP = "VERIFY_OTP";
export const SIGN_UP_ERROR = "SIGN_UP_ERROR";
export const ADD_USER_DETAILS = "ADD_USER_DETAILS";
export const LOGIN_WITH_GOOGLE = "LOGIN_WITH_GOOGLE";
export const LOGIN_WITH_EMAIL = "LOGIN_WITH_EMAIL";
export const CHECKING_ERROR = "CHECKING_ERROR";
export const RESET_ERROR_MESSAGE = "RESET_ERROR_MESSAGE";
export const LOGIN_WITH_GOOGLE_ERROR = "LOGIN_WITH_GOOGLE_ERROR";
export const RAISE_HAND = "RAISE_HAND";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";

//CHAT CONSTANTS
export const GET_ALL_CHATS = "GET_ALL_CHATS";
export const GET_ALL_MESSAGES_OF_A_CONVERSATION =
  "GET_ALL_MESSAGES_OF_A_CONVERSATION";
export const EDIT_PROFILE = "EDIT_PROFILE";

export const RESET_PROFILE_STATUS = "RESET_PROFILE_STATUS";

export const SEND_MESSAGE = "SEND_MESSAGE";
export const GET_NEXT_BATCH = "GET_NEXT_BATCH";
export const GET_DASHBOARD_STATS = "GET_DASHBOARD_STATS";
